import { render, staticRenderFns } from "./CompanyAddress.vue?vue&type=template&id=38e98c50"
import script from "./CompanyAddress.vue?vue&type=script&lang=js"
export * from "./CompanyAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports